// The contributor pressed Cancel on an upload. Every stage an upload passes through — waiting in
// the queue, hashing, the transfer itself — stops on the same signal and throws this, so whoever
// started the upload can tell a cancel apart from a failure and say nothing about it.

export function cancelledError() {
    const error = new Error("The upload was cancelled.");
    error.code = "CANCELLED";
    return error;
}

export function throwIfCancelled(signal) {
    if (signal && signal.aborted) {
        throw cancelledError();
    }
}
